import { render } from "./CrashControls.vue?vue&type=template&id=4ea62bc5&scoped=true"
import script from "./CrashControls.vue?vue&type=script&lang=js"
export * from "./CrashControls.vue?vue&type=script&lang=js"

import "./CrashControls.vue?vue&type=style&index=0&id=4ea62bc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea62bc5"]])

export default __exports__